import { useTranslation } from "react-i18next";

export function useServices() {
  const { t } = useTranslation();

  return [
    {
      id: "musicAndEntertainment",
      name: t("categories.musicAndEntertainment"),
      description: t("categories.musicAndEntertainmentDescription", {
        defaultValue:
          "Bring life to your events with live music and captivating performances.",
      }),
      imageUrl: "https://picsum.photos/400/200?random=101",
    },
    {
      id: "activitiesAndEntertainment",
      name: t("categories.activitiesAndEntertainment"),
      description: t("categories.activitiesAndEntertainmentDescription", {
        defaultValue:
          "Create unforgettable experiences with interactive and fun activities.",
      }),
      imageUrl: "https://picsum.photos/400/200?random=102",
    },
    {
      id: "foodAndDrinks",
      name: t("categories.foodAndDrinks"),
      description: t("categories.foodAndDrinksDescription", {
        defaultValue:
          "Discover culinary options tailored for every taste and occasion.",
      }),
      imageUrl: "https://picsum.photos/400/200?random=103",
    },
    {
      id: "spaceRentals",
      name: t("categories.spaceRentals"),
      description: t("categories.spaceRentalsDescription", {
        defaultValue:
          "Find the perfect venue to host your event, indoors or outdoors.",
      }),
      imageUrl: "https://picsum.photos/400/200?random=104",
    },
    {
      id: "photographyAndVideography",
      name: t("categories.photographyAndVideography"),
      description: t("categories.photographyAndVideographyDescription", {
        defaultValue:
          "Capture every moment with professional photo and video services.",
      }),
      imageUrl: "https://picsum.photos/400/200?random=105",
    },
    {
      id: "decorations",
      name: t("categories.decorations"),
      description: t("categories.decorationsDescription", {
        defaultValue:
          "Enhance your event's ambiance with stunning decorations.",
      }),
      imageUrl: "https://picsum.photos/400/200?random=106",
    },
    {
      id: "technologyAndAV",
      name: t("categories.technologyAndAV"),
      description: t("categories.technologyAndAVDescription", {
        defaultValue:
          "Equip your event with state-of-the-art audio and visual technology.",
      }),
      imageUrl: "https://picsum.photos/400/200?random=107",
    },
    {
      id: "structuresAndTents",
      name: t("categories.structuresAndTents"),
      description: t("categories.structuresAndTentsDescription", {
        defaultValue:
          "Tents, marquees, flooring, risers and stages to shape your spaces.",
      }),
      imageUrl: "https://picsum.photos/400/200?random=108",
    },
    {
      id: "lightingAndEffects",
      name: t("categories.lightingAndEffects"),
      description: t("categories.lightingAndEffectsDescription", {
        defaultValue:
          "Architectural/ambient lighting, string lights and light special effects.",
      }),
      imageUrl: "https://picsum.photos/400/200?random=109",
    },
    {
      id: "personalizedServices",
      name: t("categories.personalizedServices"),
      description: t("categories.personalizedServicesDescription", {
        defaultValue:
          "Get tailored services to make your event smooth and memorable.",
      }),
      imageUrl: "https://picsum.photos/400/200?random=110",
    },
    {
      id: "transportation",
      name: t("categories.transportation"),
      description: t("categories.transportationDescription", {
        defaultValue:
          "Organize transportation with ease for guests and equipment.",
      }),
      imageUrl: "https://picsum.photos/400/200?random=111",
    },
    {
      id: "safetyAndHealth",
      name: t("categories.safetyAndHealth"),
      description: t("categories.safetyAndHealthDescription", {
        defaultValue:
          "Ensure the safety and well-being of everyone with health and security services.",
      }),
      imageUrl: "https://picsum.photos/400/200?random=112",
    },
  ];
}
